import { uuid25 } from "../../../uuid/dist/uuid25.js";
import { query } from "../../../erd-editor-schema/dist/query/index.js";
import { OrderType } from "../../../constants/schema.js";
import { addIndexColumnAction, changeIndexColumnOrderTypeAction, moveIndexColumnAction, removeIndexColumnAction } from "./atom.actions.js";
//#region src/engine/modules/index-column/generator.actions.ts
var addIndexColumnAction$ = (indexId, columnId) => function* ({ collections }) {
	const index = query(collections).collection("indexEntities").selectById(indexId);
	if (!index) return;
	const prevIndexColumn = query(collections).collection("indexColumnEntities").selectByIds(index.seqIndexColumnIds).find((indexColumn) => indexColumn.columnId === columnId);
	if (prevIndexColumn) yield addIndexColumnAction({
		id: prevIndexColumn.id,
		indexId,
		tableId: index.tableId,
		columnId
	});
	else yield addIndexColumnAction({
		id: uuid25(),
		indexId,
		tableId: index.tableId,
		columnId
	});
};
var removeIndexColumnAction$ = (indexId, columnId) => function* ({ collections }) {
	const index = query(collections).collection("indexEntities").selectById(indexId);
	if (!index) return;
	const indexColumns = query(collections).collection("indexColumnEntities").selectByIds(index.indexColumnIds).filter((indexColumn) => indexColumn.columnId === columnId);
	for (const indexColumn of indexColumns) yield removeIndexColumnAction({
		id: indexColumn.id,
		indexId,
		tableId: index.tableId
	});
};
var changeIndexColumnOrderTypeAction$ = (indexColumnId) => function* ({ collections }) {
	const indexColumn = query(collections).collection("indexColumnEntities").selectById(indexColumnId);
	if (!indexColumn) return;
	yield changeIndexColumnOrderTypeAction({
		id: indexColumnId,
		indexId: indexColumn.indexId,
		columnId: indexColumn.columnId,
		value: indexColumn.orderType === OrderType.ASC ? OrderType.DESC : OrderType.ASC
	});
};
var moveIndexColumnAction$ = (indexColumnId, targetId) => function* ({ collections }) {
	if (indexColumnId === targetId) return;
	const indexColumn = query(collections).collection("indexColumnEntities").selectById(indexColumnId);
	if (!indexColumn) return;
	const index = query(collections).collection("indexEntities").selectById(indexColumn.indexId);
	if (!index) return;
	yield moveIndexColumnAction({
		id: indexColumnId,
		indexId: indexColumn.indexId,
		tableId: index.tableId,
		targetId
	});
};
var actions$ = {
	addIndexColumnAction$,
	removeIndexColumnAction$,
	changeIndexColumnOrderTypeAction$,
	moveIndexColumnAction$
};
//#endregion
export { actions$, addIndexColumnAction$, changeIndexColumnOrderTypeAction$, moveIndexColumnAction$, removeIndexColumnAction$ };
